<template>
  <Field
    class="textarea"
    as="div"
    :name="name"
    type="textarea"
    :rules="rules ?? ''"
    v-slot="{ field, errorMessage }"
  >
    <label
      class="input__label"
      :class="{
        'input__label--as-placeholder': !placeholder && !focus && !field.value,
        'input__label--only-mobile': labelType === 'only-mobile',
        'input__label--required': isRequired
      }"
      v-if="label"
    >
      {{ label }}
    </label>
    <div
      class="textarea__wrapper"
      :class="{
        'textarea__wrapper--focus': focus,
        'textarea__wrapper--error': !!errorMessage,
        'textarea__wrapper--valid': (!errorMessage && field.value)
      }"
    >
      <textarea
        class="textarea__field"
        type="textarea"
        :aria-label="name"
        :name="name"
        v-bind="field"
        :placeholder="inputPlaceholder"
        @blur="focus = false"
        @focus="focus = true"
        :disabled="disabled"
        :autocomplete="autocomplete"
      />
    </div>
  </Field>

  <ErrorMessage
    v-if="!suppressErrorMessages"
    as="span"
    class="input__error | input-error"
    :name="name"
  />
</template>

<script>
  import { ErrorMessage, Field } from "vee-validate";

  export default {
    components: {
      ErrorMessage,
      Field
    },
    props: {
      name: {
        type: String,
        default: ''
      },
      rules: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      labelType: {
        type: String,
        default: ''
      },
      required: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: ''
      },
      autocomplete: String,
      suppressErrorMessages: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        focus: false,
      }
    },
    computed: {
      isRequired() {
        return this.rules?.includes('required');
      },
      inputPlaceholder() {
        return this.focus ? '' : (this.placeholder || this.label) + (this.required ? ' *' : '');
      },
    },
  };

</script>
